import { useFlags } from "launchdarkly-react-client-sdk";

import { FeatureFlag } from "featureFlags/constants";
import { FlagsInterface } from "featureFlags/hooks/useAllFlags";
import { useDatabasesNames } from "services/databases/useDatabasesNames";

const DATABASE_COUNT_LIMIT = 100;
export const useDatabasePrivilegesInEdit = () => {
  const databases = useDatabasesNames();
  const flags = useFlags<Partial<FlagsInterface>>();
  const limitCount =
    flags[FeatureFlag.FireboltAppDatabasesLimitForPrivilegesLoad] ||
    DATABASE_COUNT_LIMIT;
  if (
    databases.length <= limitCount &&
    flags[FeatureFlag.FireboltAppEnableDatabasesPrivilegesInEdit]
  ) {
    return true;
  }
  return false;
};
